import { Delivery } from './delivery.model';

export interface InboxDelivery extends Delivery {
  sentBy: string;
  countDown: string;
  resendRequested?: boolean;
}
